var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _g, _text25, _g2, _text26, _text27, _g3, _text28, _text29, _text30, _b, _div, _text31, _g4, _br, _text32, _g5, _text33, _rect2, _g6, _br2, _text34, _rect3, _g7, _text35, _text36, _g8, _text37, _text38, _text39, _text40, _text41, _text42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#ffffff",
      backgroundColor: "#ffffff",
      colorScheme: "light"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1372px",
    height: "781px",
    viewBox: "-0.5 -0.5 1372 781",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36\" version=\"26.0.16\" scale=\"1\" border=\"0\"> <diagram id=\"R2lEEEUBdFMjLlhIrx00\" name=\"Page-1\"> <mxGraphModel dx=\"2403\" dy=\"874\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"850\" pageHeight=\"1100\" background=\"none\" math=\"0\" shadow=\"0\" extFonts=\"Permanent Marker^https://fonts.googleapis.com/css?family=Permanent+Marker\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"RyXrWw_IlzlAukWj9gDp-8\" value=\"A\" style=\"rounded=0;whiteSpace=wrap;html=1;fillColor=#C9BCFF;strokeColor=#9673a6;fontColor=none;noLabel=1;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"-120\" y=\"140\" width=\"1370\" height=\"780\" as=\"geometry\" /> </mxCell> <mxCell id=\"A6JmoFz1TFm3R6muNgtk-1\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#b0e3e6;strokeColor=#0e8088;opacity=40;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"340\" y=\"780\" width=\"170\" height=\"90\" as=\"geometry\" /> </mxCell> <mxCell id=\"RyXrWw_IlzlAukWj9gDp-9\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#b0e3e6;strokeColor=#0e8088;opacity=40;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"30\" y=\"180\" width=\"870\" height=\"600\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--25\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;opacity=20;fillColor=#fff2cc;strokeColor=#d6b656;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"38\" y=\"369.84\" width=\"200\" height=\"190.16\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-13\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#ffffff;endArrow=none;startFill=0;entryX=0.467;entryY=0.942;entryDx=0;entryDy=0;entryPerimeter=0;\" parent=\"1\" source=\"L1MROEutppAufzN2r79q-3\" edge=\"1\" target=\"L1MROEutppAufzN2r79q-5\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"1075\" y=\"210\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-3\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#ffff88;strokeColor=#36393d;opacity=20;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"955\" y=\"250\" width=\"120\" height=\"450\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-4\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;opacity=20;fillColor=#ffe6cc;strokeColor=#d79b00;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1075\" y=\"250\" width=\"120\" height=\"450\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--7\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;opacity=20;fillColor=#ffcccc;strokeColor=#36393d;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"250\" y=\"230\" width=\"640\" height=\"510\" as=\"geometry\" /> </mxCell> <mxCell id=\"macv8HNG5b3oE9DqVLA9-11\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"R7SOZR6RymNMCeq-2xTA-10\" target=\"R7SOZR6RymNMCeq-2xTA-25\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"KinoSXWmXAQI8Y48_NnL-7\" style=\"edgeStyle=none;curved=0;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=20;fontSize=12;startSize=8;endSize=8;entryPerimeter=0;\" parent=\"1\" target=\"soP93XkfWnE7ahWj83kz-59\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"740\" y=\"336\" as=\"sourcePoint\" /> <mxPoint x=\"940\" y=\"380\" as=\"targetPoint\" /> <Array as=\"points\"> <mxPoint x=\"870\" y=\"336\" /> <mxPoint x=\"870\" y=\"375\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"R7SOZR6RymNMCeq-2xTA-10\" value=\"pavm (presales)\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#a0522d;strokeColor=#6D1F00;align=center;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"590\" y=\"306\" width=\"150\" height=\"50\" as=\"geometry\" /> </mxCell> <mxCell id=\"R7SOZR6RymNMCeq-2xTA-25\" value=\"&lt;div style=&quot;&quot;&gt;Mongo&lt;/div&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;fillColor=#6d8764;strokeColor=#3A5431;align=center;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"730\" y=\"255\" width=\"63\" height=\"45\" as=\"geometry\" /> </mxCell> <mxCell id=\"macv8HNG5b3oE9DqVLA9-12\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-1\" target=\"3Dsf5oKocH91LaM-3EqL-9\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-1\" value=\"pavm (la-jolla)\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;size=20;fillColor=#a0522d;strokeColor=#6D1F00;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"590\" y=\"550\" width=\"150\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--43\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-2\" target=\"3Dsf5oKocH91LaM-3EqL-11\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-2\" value=\"user-service\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;size=20;fillColor=#76608a;strokeColor=#432D57;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"590\" y=\"660\" width=\"150\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-25\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-3\" target=\"3Dsf5oKocH91LaM-3EqL-11\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"680\" y=\"490\" /> <mxPoint x=\"820\" y=\"490\" /> <mxPoint x=\"820\" y=\"840\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"macv8HNG5b3oE9DqVLA9-1\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;strokeColor=default;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-3\" target=\"3Dsf5oKocH91LaM-3EqL-8\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"670\" y=\"400\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"macv8HNG5b3oE9DqVLA9-8\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=20;fontColor=#000000;entryPerimeter=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-3\" target=\"soP93XkfWnE7ahWj83kz-75\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"885\" y=\"509.6700000000001\" as=\"targetPoint\" /> <Array as=\"points\"> <mxPoint x=\"870\" y=\"449\" /> <mxPoint x=\"870\" y=\"505\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-3\" value=\"pavm (newport)\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;size=20;fillColor=#a0522d;strokeColor=#6D1F00;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"590\" y=\"420\" width=\"150\" height=\"58.5\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-8\" value=\"&lt;div style=&quot;&quot;&gt;Mongo&lt;/div&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;fillColor=#6d8764;strokeColor=#3A5431;align=center;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"730\" y=\"380\" width=\"64\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-9\" value=\"&lt;div style=&quot;&quot;&gt;Mongo&lt;/div&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;fillColor=#6d8764;strokeColor=#3A5431;align=center;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"730\" y=\"510\" width=\"64\" height=\"39.67\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-11\" value=\"&lt;div style=&quot;text-align: left;&quot;&gt;Mongo&lt;/div&gt;&lt;div style=&quot;text-align: left;&quot;&gt;(users)&lt;/div&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;fillColor=#6d8764;strokeColor=#3A5431;fontColor=#ffffff;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"620\" y=\"808.09\" width=\"90\" height=\"55.64\" as=\"geometry\" /> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-24\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-1\" target=\"3Dsf5oKocH91LaM-3EqL-11\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"680\" y=\"620\" /> <mxPoint x=\"800\" y=\"620\" /> <mxPoint x=\"800\" y=\"830\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-26\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#000000;endArrow=none;startFill=0;\" parent=\"1\" source=\"R7SOZR6RymNMCeq-2xTA-10\" target=\"3Dsf5oKocH91LaM-3EqL-11\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"680\" y=\"370\" /> <mxPoint x=\"840\" y=\"370\" /> <mxPoint x=\"840\" y=\"850\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-61\" value=\"\" style=\"endArrow=classic;html=1;rounded=0;startArrow=oval;startFill=1;fontColor=#000000;\" parent=\"1\" edge=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"500\" y=\"329.71999999999997\" as=\"sourcePoint\" /> <mxPoint x=\"590\" y=\"330.28\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-64\" value=\"\" style=\"endArrow=classic;html=1;rounded=0;startArrow=oval;startFill=1;fontColor=#000000;\" parent=\"1\" edge=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"500\" y=\"449.44000000000005\" as=\"sourcePoint\" /> <mxPoint x=\"590\" y=\"450\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"3Dsf5oKocH91LaM-3EqL-68\" value=\"\" style=\"sketch=0;aspect=fixed;pointerEvents=1;shadow=0;dashed=0;html=1;strokeColor=#B09500;labelPosition=center;verticalLabelPosition=bottom;verticalAlign=top;align=center;fillColor=#e3c800;shape=mxgraph.mscae.enterprise.lock;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"490\" y=\"414.7\" width=\"20\" height=\"25.64\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-58\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"375\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-57\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"375\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-56\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"375\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-61\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"355\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-60\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"355\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-59\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"355\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-70\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"505\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-71\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"505\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-72\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"505\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-73\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"485\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-74\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"485\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-75\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"485\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-80\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"639.67\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-81\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"639.67\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-82\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"639.67\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-83\" value=\"DDA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1110\" y=\"619.67\" width=\"110\" height=\"40.33\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-84\" value=\"DSA\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"619.67\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"soP93XkfWnE7ahWj83kz-85\" value=\"DC\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;strokeColor=#FFFFFF;fontColor=light-dark(#ffffff, #ededed);\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"940\" y=\"619.67\" width=\"110\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-1\" value=\"&lt;b style=&quot;border-color: var(--darkreader-border--border-color); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; darkreader-inline-color: light-dark(#d8d4cf, #3a3632); darkreader-inline-border: var(--darkreader-border--darkreader-border--border-color);&quot; data-darkreader-inline-color=&quot;&quot; data-darkreader-inline-border=&quot;&quot;&gt;&lt;b style=&quot;border-color: var(--darkreader-border--border-color);&quot;&gt;s-comm&lt;/b&gt;&lt;/b&gt;&lt;div&gt;&lt;b style=&quot;border-color: var(--darkreader-border--border-color); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; darkreader-inline-color: light-dark(#d8d4cf, #3a3632); darkreader-inline-border: var(--darkreader-border--darkreader-border--border-color);&quot; data-darkreader-inline-color=&quot;&quot; data-darkreader-inline-border=&quot;&quot;&gt;&lt;b style=&quot;border-color: var(--darkreader-border--border-color);&quot;&gt;(&lt;/b&gt;public)&lt;/b&gt;&lt;/div&gt;\" style=\"text;whiteSpace=wrap;html=1;fontColor=#000000;align=center;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"965\" y=\"282.18\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-2\" value=\"&lt;b style=&quot;border-color: var(--darkreader-border--border-color); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; darkreader-inline-color: light-dark(#d8d4cf, #3a3632); darkreader-inline-border: var(--darkreader-border--darkreader-border--border-color);&quot; data-darkreader-inline-color=&quot;&quot; data-darkreader-inline-border=&quot;&quot;&gt;s-stat&lt;/b&gt;&lt;div&gt;&lt;b style=&quot;border-color: var(--darkreader-border--border-color); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; darkreader-inline-color: light-dark(#d8d4cf, #3a3632); darkreader-inline-border: var(--darkreader-border--darkreader-border--border-color);&quot; data-darkreader-inline-color=&quot;&quot; data-darkreader-inline-border=&quot;&quot;&gt;(private)&lt;/b&gt;&lt;/div&gt;\" style=\"text;whiteSpace=wrap;html=1;fontColor=#000000;align=center;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1087.5\" y=\"282.18\" width=\"95\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-5\" value=\"/usr/local/grace\" style=\"text;html=1;align=center;verticalAlign=middle;resizable=0;points=[];autosize=1;strokeColor=#B09500;fillColor=#e3c800;fontStyle=1;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"1030\" y=\"180\" width=\"100\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"L1MROEutppAufzN2r79q-11\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#ffffff;endArrow=none;startFill=0;entryX=0.464;entryY=1.012;entryDx=0;entryDy=0;entryPerimeter=0;\" parent=\"1\" source=\"L1MROEutppAufzN2r79q-4\" target=\"L1MROEutppAufzN2r79q-5\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"1077\" y=\"210\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"RyXrWw_IlzlAukWj9gDp-10\" value=\"AWS\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontSize=15;fontStyle=1;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"435\" y=\"150.00000000000003\" width=\"120\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--39\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--1\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"500\" y=\"330\" as=\"targetPoint\" /> <Array as=\"points\"> <mxPoint x=\"470\" y=\"382\" /> <mxPoint x=\"470\" y=\"330\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--1\" value=\"portal\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;size=20;fillColor=#ffcccc;strokeColor=#36393d;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"290\" y=\"349.7\" width=\"130\" height=\"65\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--34\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--2\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"500\" y=\"450\" as=\"targetPoint\" /> <Array as=\"points\"> <mxPoint x=\"470\" y=\"600\" /> <mxPoint x=\"470\" y=\"450\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--2\" value=\"portal\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;size=20;fillColor=#ffcccc;strokeColor=#36393d;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"290\" y=\"549.5\" width=\"130\" height=\"70.17\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--5\" value=\"&lt;b&gt;LB&amp;nbsp;&lt;/b&gt;&lt;div&gt;&lt;b&gt;(application)&lt;/b&gt;&lt;/div&gt;\" style=\"html=1;whiteSpace=wrap;aspect=fixed;shape=isoRectangle;fillColor=#e3c800;strokeColor=#B09500;labelBackgroundColor=none;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"60\" y=\"434.66999999999996\" width=\"150\" height=\"90\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--8\" value=\"&lt;b style=&quot;border-color: var(--darkreader-border--border-color); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; darkreader-inline-color: light-dark(#d8d4cf, #3a3632); darkreader-inline-border: var(--darkreader-border--darkreader-border--border-color);&quot; data-darkreader-inline-color=&quot;&quot; data-darkreader-inline-border=&quot;&quot;&gt;grace.isstools.com&lt;br&gt;&lt;/b&gt;\" style=\"text;whiteSpace=wrap;html=1;align=center;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"210\" y=\"316\" width=\"275.5\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--18\" value=\"PRIVATE DNS\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontSize=12;fontStyle=1;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"520.5\" y=\"240.00000000000003\" width=\"120\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--24\" value=\"\" style=\"sketch=0;aspect=fixed;pointerEvents=1;shadow=0;dashed=0;html=1;strokeColor=#B09500;labelPosition=center;verticalLabelPosition=bottom;verticalAlign=top;align=center;fillColor=#e3c800;shape=mxgraph.mscae.enterprise.lock;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"490\" y=\"289.3599999999999\" width=\"20\" height=\"25.64\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--26\" value=\"PUBLIC IP &lt;br&gt;+ FIREWALL/IP WHITELIST\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontSize=12;fontStyle=1;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"52.5\" y=\"390.00000000000006\" width=\"165\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--29\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=22.5;entryPerimeter=0;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--5\" target=\"4QQG_8IH3QX1jVuvBs9--1\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--31\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=25.085;entryPerimeter=0;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--5\" target=\"4QQG_8IH3QX1jVuvBs9--2\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--42\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=20;entryPerimeter=0;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--1\" target=\"3Dsf5oKocH91LaM-3EqL-2\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"560\" y=\"382\" /> <mxPoint x=\"560\" y=\"680\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--44\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=40;entryPerimeter=0;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--2\" target=\"3Dsf5oKocH91LaM-3EqL-2\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"470\" y=\"600\" /> <mxPoint x=\"470\" y=\"700\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--59\" value=\"\" style=\"verticalLabelPosition=bottom;html=1;verticalAlign=top;align=center;strokeColor=#36393d;fillColor=#ffff88;shape=mxgraph.azure.laptop;pointerEvents=1;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"-100\" y=\"447\" width=\"108.88\" height=\"65.33\" as=\"geometry\" /> </mxCell> <mxCell id=\"4QQG_8IH3QX1jVuvBs9--61\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=-0.007;entryY=0.501;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#000000;\" parent=\"1\" source=\"4QQG_8IH3QX1jVuvBs9--59\" target=\"4QQG_8IH3QX1jVuvBs9--5\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"A6JmoFz1TFm3R6muNgtk-2\" value=\"atlas (hosted)\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontSize=15;fontStyle=1;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"605\" y=\"880\" width=\"120\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"KinoSXWmXAQI8Y48_NnL-6\" style=\"edgeStyle=none;curved=0;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=0;entryPerimeter=0;fontSize=12;startSize=8;endSize=8;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-1\" target=\"soP93XkfWnE7ahWj83kz-82\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"870\" y=\"580\" /> <mxPoint x=\"870\" y=\"640\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-1\" value=\"S3\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fontSize=13;strokeColor=#FFFFFF;fillColor=#000000;fontColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"360\" y=\"802.72\" width=\"130\" height=\"42.28\" as=\"geometry\" /> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-12\" value=\"fwupdate.signed\" style=\"text;html=1;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontSize=16;fontColor=#000000;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"49.99000000000001\" y=\"845.9999999999999\" width=\"110\" height=\"17.73\" as=\"geometry\" /> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-13\" value=\"\" style=\"verticalLabelPosition=bottom;html=1;verticalAlign=top;align=center;strokeColor=none;fillColor=#00BEF2;shape=mxgraph.azure.cloud_service_package_file;fontSize=16;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"76.87\" y=\"802.72\" width=\"56.25\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-30\" style=\"edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontSize=12;startSize=8;endSize=8;\" parent=\"1\" source=\"nxQMmvYxkB1rS9AH893d-20\" target=\"nxQMmvYxkB1rS9AH893d-1\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-36\" style=\"edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontSize=12;startSize=8;endSize=8;fillColor=#0050ef;strokeColor=#001DBC;entryX=0;entryY=0;entryDx=10;entryDy=48.5;entryPerimeter=0;\" parent=\"1\" target=\"3Dsf5oKocH91LaM-3EqL-3\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"430\" y=\"800\" as=\"sourcePoint\" /> <Array as=\"points\"> <mxPoint x=\"540\" y=\"650\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-42\" value=\"&amp;nbsp;2&amp;nbsp;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontSize=14;labelBackgroundColor=#0000FF;fontColor=#FFFFFF;\" parent=\"nxQMmvYxkB1rS9AH893d-36\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.2245\" y=\"8\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"17\" y=\"2\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-20\" value=\"ARTIFACTS\" style=\"shape=cube;whiteSpace=wrap;html=1;boundedLbl=1;backgroundOutline=1;darkOpacity=0.05;darkOpacity2=0.1;fillColor=#000000;fontColor=#FFFFFF;strokeColor=#FFFFFF;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"200\" y=\"801.44\" width=\"130\" height=\"42.28\" as=\"geometry\" /> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-26\" style=\"edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=11.14;entryPerimeter=0;fontSize=12;startSize=8;endSize=8;\" parent=\"1\" source=\"nxQMmvYxkB1rS9AH893d-13\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"200.00000000000045\" y=\"822.5800000000002\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-33\" style=\"edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontSize=9;startSize=8;endSize=8;fillColor=#0050ef;strokeColor=#001DBC;exitX=0.022;exitY=0.748;exitDx=0;exitDy=0;exitPerimeter=0;\" parent=\"1\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"593.3000000000002\" y=\"463.75800000000004\" as=\"sourcePoint\" /> <mxPoint x=\"420\" y=\"800\" as=\"targetPoint\" /> <Array as=\"points\"> <mxPoint x=\"490\" y=\"590\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-35\" value=\"&lt;font style=&quot;font-size: 12px;&quot;&gt;&amp;nbsp;fwupdate&amp;nbsp;&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontSize=16;fontColor=#FFFFFF;labelBackgroundColor=#0000FF;\" parent=\"nxQMmvYxkB1rS9AH893d-33\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"0.1593\" y=\"20\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"23\" y=\"-31\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-41\" value=\"&amp;nbsp;1&amp;nbsp;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontSize=14;labelBackgroundColor=#0000FF;fontColor=#FFFFFF;\" parent=\"nxQMmvYxkB1rS9AH893d-33\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.4064\" y=\"7\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"-16\" y=\"-7\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-39\" style=\"edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0;entryDx=0;entryDy=0;entryPerimeter=0;fontSize=12;startSize=8;endSize=8;exitX=1.017;exitY=0.496;exitDx=0;exitDy=0;exitPerimeter=0;fillColor=#0050ef;strokeColor=#001DBC;\" parent=\"1\" source=\"3Dsf5oKocH91LaM-3EqL-3\" target=\"soP93XkfWnE7ahWj83kz-75\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"870\" y=\"410\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"nxQMmvYxkB1rS9AH893d-40\" value=\"&amp;nbsp;3&amp;nbsp;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontSize=14;labelBackgroundColor=#0000FF;fontColor=#FFFFFF;\" parent=\"nxQMmvYxkB1rS9AH893d-39\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.0318\" y=\"-24\" relative=\"1\" as=\"geometry\"> <mxPoint y=\"-18\" as=\"offset\" /> </mxGeometry> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css2?family=Permanent+Marker:wght@400;500);&#xa;"))), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "RyXrWw_IlzlAukWj9gDp-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1370,
    height: 780,
    fill: "#c9bcff",
    stroke: "#9673a6",
    pointerEvents: "all",
    style: {
      fill: "rgb(201, 188, 255)",
      stroke: "rgb(150, 115, 166)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A6JmoFz1TFm3R6muNgtk-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 640,
    width: 170,
    height: 90,
    rx: 13.5,
    ry: 13.5,
    fillOpacity: 0.4,
    fill: "#b0e3e6",
    stroke: "#0e8088",
    strokeOpacity: 0.4,
    pointerEvents: "all",
    style: {
      fill: "rgb(176, 227, 230)",
      stroke: "rgb(14, 128, 136)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "RyXrWw_IlzlAukWj9gDp-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 40,
    width: 870,
    height: 600,
    rx: 90,
    ry: 90,
    fillOpacity: 0.4,
    fill: "#b0e3e6",
    stroke: "#0e8088",
    strokeOpacity: 0.4,
    pointerEvents: "all",
    style: {
      fill: "rgb(176, 227, 230)",
      stroke: "rgb(14, 128, 136)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 229.84,
    width: 200,
    height: 190.16,
    rx: 28.52,
    ry: 28.52,
    fillOpacity: 0.2,
    fill: "#fff2cc",
    stroke: "#d6b656",
    strokeOpacity: 0.2,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 242, 204)",
      stroke: "rgb(214, 182, 86)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1135 110 L 1135 90 L 1196.75 90 L 1196.7 68.26",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1075,
    y: 110,
    width: 120,
    height: 450,
    rx: 18,
    ry: 18,
    fillOpacity: 0.2,
    fill: "#ffff88",
    stroke: "#36393d",
    strokeOpacity: 0.2,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 136)",
      stroke: "rgb(54, 57, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1195,
    y: 110,
    width: 120,
    height: 450,
    rx: 18,
    ry: 18,
    fillOpacity: 0.2,
    fill: "#ffe6cc",
    stroke: "#d79b00",
    strokeOpacity: 0.2,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 230, 204)",
      stroke: "rgb(215, 155, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 90,
    width: 640,
    height: 510,
    rx: 76.5,
    ry: 76.5,
    fillOpacity: 0.2,
    fill: "#ffcccc",
    stroke: "#36393d",
    strokeOpacity: 0.2,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 204, 204)",
      stroke: "rgb(54, 57, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "macv8HNG5b3oE9DqVLA9-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 785 166 L 785 137.5 L 850 137.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "KinoSXWmXAQI8Y48_NnL-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 860 196 L 990 196 L 990 235 L 1052.13 235",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1058.88 235 L 1049.88 239.5 L 1052.13 235 L 1049.88 230.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "R7SOZR6RymNMCeq-2xTA-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 710 166 L 840 166 L 860 186 L 860 216 L 730 216 L 710 196 L 710 166 Z",
    fill: "#a0522d",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(160, 82, 45)",
      stroke: "rgb(109, 31, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 166 L 840 166 L 860 186 L 730 186 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 166 L 730 186 L 730 216 L 710 196 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 730 216 L 730 186 L 710 166 M 730 186 L 860 186",
    fill: "none",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(109, 31, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 201,
      marginLeft: 731
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "pavm (presales)")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 795,
    y: 205,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "pavm (presales)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "R7SOZR6RymNMCeq-2xTA-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 850 121 C 850 113 913 113 913 121 L 913 154 C 913 162 850 162 850 154 Z",
    fill: "#6d8764",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(109, 135, 100)",
      stroke: "rgb(58, 84, 49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 850 121 C 850 127 913 127 913 121 M 850 124 C 850 130 913 130 913 124 M 850 127 C 850 133 913 133 913 127",
    fill: "none",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(58, 84, 49)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 61,
      height: 1,
      paddingTop: 146,
      marginLeft: 851
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {}
  }, "Mongo"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 881,
    y: 149,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mongo")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "macv8HNG5b3oE9DqVLA9-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 785 410 L 785 389.75 L 850 389.83",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 710 410 L 840 410 L 860 430 L 860 470 L 730 470 L 710 450 L 710 410 Z",
    fill: "#a0522d",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(160, 82, 45)",
      stroke: "rgb(109, 31, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 410 L 840 410 L 860 430 L 730 430 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 410 L 730 430 L 730 470 L 710 450 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 730 470 L 730 430 L 710 410 M 730 430 L 860 430",
    fill: "none",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(109, 31, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 450,
      marginLeft: 731
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "pavm (la-jolla)")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 795,
    y: 454,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "pavm (la-jolla)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 785 580 L 785 668.09",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 710 520 L 840 520 L 860 540 L 860 580 L 730 580 L 710 560 L 710 520 Z",
    fill: "#76608a",
    stroke: "#432d57",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(118, 96, 138)",
      stroke: "rgb(67, 45, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 520 L 840 520 L 860 540 L 730 540 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 520 L 730 540 L 730 580 L 710 560 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 730 580 L 730 540 L 710 520 M 730 540 L 860 540",
    fill: "none",
    stroke: "#432d57",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(67, 45, 87)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 560,
      marginLeft: 731
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "user-service")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 795,
    y: 564,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "user-service")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 800 338.5 L 800 350 L 940 350 L 940 700 L 830 700",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "macv8HNG5b3oE9DqVLA9-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 790 280 L 790 260 L 850 260",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "macv8HNG5b3oE9DqVLA9-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 860 309.25 L 990 309.25 L 990 365 L 1053.63 365",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1058.88 365 L 1051.88 368.5 L 1053.63 365 L 1051.88 361.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 710 280 L 840 280 L 860 300 L 860 338.5 L 730 338.5 L 710 318.5 L 710 280 Z",
    fill: "#a0522d",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(160, 82, 45)",
      stroke: "rgb(109, 31, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 280 L 840 280 L 860 300 L 730 300 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 710 280 L 730 300 L 730 338.5 L 710 318.5 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 730 338.5 L 730 300 L 710 280 M 730 300 L 860 300",
    fill: "none",
    stroke: "#6d1f00",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(109, 31, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 319,
      marginLeft: 731
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "pavm (newport)")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 795,
    y: 323,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "pavm (newport)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 850 245 C 850 238.33 914 238.33 914 245 L 914 275 C 914 281.67 850 281.67 850 275 Z",
    fill: "#6d8764",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(109, 135, 100)",
      stroke: "rgb(58, 84, 49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 850 245 C 850 250 914 250 914 245 M 850 247.5 C 850 252.5 914 252.5 914 247.5 M 850 250 C 850 255 914 255 914 250",
    fill: "none",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(58, 84, 49)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 62,
      height: 1,
      paddingTop: 266,
      marginLeft: 851
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {}
  }, "Mongo"))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 270,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mongo")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 850 375 C 850 368.33 914 368.33 914 375 L 914 404.67 C 914 411.34 850 411.34 850 404.67 Z",
    fill: "#6d8764",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(109, 135, 100)",
      stroke: "rgb(58, 84, 49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 850 375 C 850 380 914 380 914 375 M 850 377.5 C 850 382.5 914 382.5 914 377.5 M 850 380 C 850 385 914 385 914 380",
    fill: "none",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(58, 84, 49)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 62,
      height: 1,
      paddingTop: 396,
      marginLeft: 851
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {}
  }, "Mongo"))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 400,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mongo")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 740 675.09 C 740 665.76 830 665.76 830 675.09 L 830 716.73 C 830 726.06 740 726.06 740 716.73 Z",
    fill: "#6d8764",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(109, 135, 100)",
      stroke: "rgb(58, 84, 49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 740 675.09 C 740 682.09 830 682.09 830 675.09 M 740 678.59 C 740 685.59 830 685.59 830 678.59 M 740 682.09 C 740 689.09 830 689.09 830 682.09",
    fill: "none",
    stroke: "#3a5431",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(58, 84, 49)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 705,
      marginLeft: 741
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "left"
    }
  }, "Mongo"), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "left"
    }
  }, "(users)"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 785,
    y: 709,
    fill: "#ffffff",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mongo...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 800 470 L 800 480 L 920 480 L 920 690 L 830 690",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 800 216 L 800 230 L 960 230 L 960 710 L 830 710",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 623 189.74 L 703.63 190.24",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620,
    cy: 189.72,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.88 190.27 L 701.86 193.73 L 703.63 190.24 L 701.9 186.73 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-64"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 623 309.46 L 703.63 309.96",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620,
    cy: 309.44,
    rx: 3,
    ry: 3,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.88 309.99 L 701.86 313.45 L 703.63 309.96 L 701.9 306.45 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Dsf5oKocH91LaM-3EqL-68"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 274.7,
    width: 20,
    height: 25.64,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 611.19 300.34 C 610.61 300.16 610.16 299.7 610 299.12 L 610 286.24 C 610.14 285.63 610.59 285.14 611.19 284.94 L 612.66 284.94 L 612.66 281.53 C 612.68 279.72 613.44 277.99 614.77 276.75 C 616.1 275.51 617.9 274.86 619.73 274.95 C 621.65 274.7 623.59 275.28 625.05 276.54 C 626.5 277.8 627.34 279.62 627.34 281.53 L 627.34 284.94 L 628.6 284.94 C 629.28 285.08 629.83 285.58 630 286.24 L 630 299.12 C 629.82 299.71 629.34 300.18 628.73 300.34 Z M 621 297.82 L 621 292.49 C 621.94 292.04 622.45 291.01 622.22 290 C 621.99 288.99 621.08 288.27 620.03 288.27 C 618.97 288.27 618.06 288.99 617.83 290 C 617.6 291.01 618.11 292.04 619.06 292.49 L 619.06 297.82 Z M 624.93 284.94 L 624.93 281.4 C 624.72 278.9 622.52 277.03 619.99 277.19 C 617.47 277.06 615.3 278.92 615.1 281.4 L 615.1 284.94 Z",
    fill: "#e3c800",
    stroke: "#b09500",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(227, 200, 0)",
      stroke: "rgb(176, 149, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 235 L 1320 235 L 1340 255 L 1340 275 L 1250 275 L 1230 255 L 1230 235 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 235 L 1320 235 L 1340 255 L 1250 255 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 235 L 1250 255 L 1250 275 L 1230 255 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 275 L 1250 255 L 1230 235 M 1250 255 L 1340 255",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 265,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 269,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 235 L 1230 235 L 1250 255 L 1250 275 L 1170 275 L 1150 255 L 1150 235 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 235 L 1230 235 L 1250 255 L 1170 255 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 235 L 1170 255 L 1170 275 L 1150 255 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 275 L 1170 255 L 1150 235 M 1170 255 L 1250 255",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 265,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 269,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-56"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 235 L 1150 235 L 1170 255 L 1170 275 L 1080 275 L 1060 255 L 1060 235 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 235 L 1150 235 L 1170 255 L 1080 255 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 235 L 1080 255 L 1080 275 L 1060 255 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 275 L 1080 255 L 1060 235 M 1080 255 L 1170 255",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 265,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 269,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 215 L 1320 215 L 1340 235 L 1340 255 L 1250 255 L 1230 235 L 1230 215 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 215 L 1320 215 L 1340 235 L 1250 235 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 215 L 1250 235 L 1250 255 L 1230 235 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 255 L 1250 235 L 1230 215 M 1250 235 L 1340 235",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 245,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 249,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 215 L 1230 215 L 1250 235 L 1250 255 L 1170 255 L 1150 235 L 1150 215 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 215 L 1230 215 L 1250 235 L 1170 235 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 215 L 1170 235 L 1170 255 L 1150 235 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 255 L 1170 235 L 1150 215 M 1170 235 L 1250 235",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 245,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 249,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 215 L 1150 215 L 1170 235 L 1170 255 L 1080 255 L 1060 235 L 1060 215 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 215 L 1150 215 L 1170 235 L 1080 235 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 215 L 1080 235 L 1080 255 L 1060 235 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 255 L 1080 235 L 1060 215 M 1080 235 L 1170 235",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 245,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 249,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 365 L 1320 365 L 1340 385 L 1340 405 L 1250 405 L 1230 385 L 1230 365 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 365 L 1320 365 L 1340 385 L 1250 385 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 365 L 1250 385 L 1250 405 L 1230 385 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 405 L 1250 385 L 1230 365 M 1250 385 L 1340 385",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 395,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 399,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-71"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 365 L 1230 365 L 1250 385 L 1250 405 L 1170 405 L 1150 385 L 1150 365 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 365 L 1230 365 L 1250 385 L 1170 385 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 365 L 1170 385 L 1170 405 L 1150 385 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 405 L 1170 385 L 1150 365 M 1170 385 L 1250 385",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 395,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 399,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 365 L 1150 365 L 1170 385 L 1170 405 L 1080 405 L 1060 385 L 1060 365 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 365 L 1150 365 L 1170 385 L 1080 385 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 365 L 1080 385 L 1080 405 L 1060 385 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 405 L 1080 385 L 1060 365 M 1080 385 L 1170 385",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 395,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 399,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-73"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 345 L 1320 345 L 1340 365 L 1340 385 L 1250 385 L 1230 365 L 1230 345 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 345 L 1320 345 L 1340 365 L 1250 365 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 345 L 1250 365 L 1250 385 L 1230 365 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 385 L 1250 365 L 1230 345 M 1250 365 L 1340 365",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 375,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 379,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 345 L 1230 345 L 1250 365 L 1250 385 L 1170 385 L 1150 365 L 1150 345 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 345 L 1230 345 L 1250 365 L 1170 365 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 345 L 1170 365 L 1170 385 L 1150 365 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 385 L 1170 365 L 1150 345 M 1170 365 L 1250 365",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 375,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 379,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 345 L 1150 345 L 1170 365 L 1170 385 L 1080 385 L 1060 365 L 1060 345 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 345 L 1150 345 L 1170 365 L 1080 365 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 345 L 1080 365 L 1080 385 L 1060 365 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 385 L 1080 365 L 1060 345 M 1080 365 L 1170 365",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 375,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 379,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 499.67 L 1320 499.67 L 1340 519.67 L 1340 539.67 L 1250 539.67 L 1230 519.67 L 1230 499.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 499.67 L 1320 499.67 L 1340 519.67 L 1250 519.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 499.67 L 1250 519.67 L 1250 539.67 L 1230 519.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 539.67 L 1250 519.67 L 1230 499.67 M 1250 519.67 L 1340 519.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 530,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 533,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 499.67 L 1230 499.67 L 1250 519.67 L 1250 539.67 L 1170 539.67 L 1150 519.67 L 1150 499.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 499.67 L 1230 499.67 L 1250 519.67 L 1170 519.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 499.67 L 1170 519.67 L 1170 539.67 L 1150 519.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 539.67 L 1170 519.67 L 1150 499.67 M 1170 519.67 L 1250 519.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 530,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 533,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-82"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 499.67 L 1150 499.67 L 1170 519.67 L 1170 539.67 L 1080 539.67 L 1060 519.67 L 1060 499.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 499.67 L 1150 499.67 L 1170 519.67 L 1080 519.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 499.67 L 1080 519.67 L 1080 539.67 L 1060 519.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 539.67 L 1080 519.67 L 1060 499.67 M 1080 519.67 L 1170 519.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 530,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 533,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1230 479.67 L 1320 479.67 L 1340 499.67 L 1340 520 L 1250 520 L 1230 500 L 1230 479.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 479.67 L 1320 479.67 L 1340 499.67 L 1250 499.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1230 479.67 L 1250 499.67 L 1250 520 L 1230 500 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1250 520 L 1250 499.67 L 1230 479.67 M 1250 499.67 L 1340 499.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 510,
      marginLeft: 1251
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DDA")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1295,
    y: 513,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DDA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1150 479.67 L 1230 479.67 L 1250 499.67 L 1250 519.67 L 1170 519.67 L 1150 499.67 L 1150 479.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 479.67 L 1230 479.67 L 1250 499.67 L 1170 499.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1150 479.67 L 1170 499.67 L 1170 519.67 L 1150 499.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1170 519.67 L 1170 499.67 L 1150 479.67 M 1170 499.67 L 1250 499.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 510,
      marginLeft: 1171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DSA")))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 513,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DSA")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "soP93XkfWnE7ahWj83kz-85"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1060 479.67 L 1150 479.67 L 1170 499.67 L 1170 519.67 L 1080 519.67 L 1060 499.67 L 1060 479.67 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 479.67 L 1150 479.67 L 1170 499.67 L 1080 499.67 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1060 479.67 L 1080 499.67 L 1080 519.67 L 1060 499.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080 519.67 L 1080 499.67 L 1060 479.67 M 1080 499.67 L 1170 499.67",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 510,
      marginLeft: 1081
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#ffffff",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "DC")))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1125,
    y: 513,
    fill: "light-dark(#ffffff, #ededed)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1085,
    y: 142.18,
    width: 100,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 149,
      marginLeft: 1086
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    "data-darkreader-inline-border": "",
    "data-darkreader-inline-color": "",
    style: {
      borderColor: "var(--darkreader-border--border-color)",
      fontFamily: "Helvetica",
      fontSize: 12,
      fontStyle: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      letterSpacing: "normal",
      orphans: 2,
      textIndent: 0,
      textTransform: "none",
      widows: 2,
      wordSpacing: 0,
      WebkitTextStrokeWidth: 0,
      textDecorationThickness: "initial",
      textDecorationStyle: "initial",
      textDecorationColor: "initial",
      darkreaderInlineColor: "light-dark(#d8d4cf, #3a3632)",
      darkreaderInlineBorder: "var(--darkreader-border--darkreader-border--border-color)"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--darkreader-border--border-color)"
    }
  }, "s-comm")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
    "data-darkreader-inline-border": "",
    "data-darkreader-inline-color": "",
    style: {
      borderColor: "var(--darkreader-border--border-color)",
      fontFamily: "Helvetica",
      fontSize: 12,
      fontStyle: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      letterSpacing: "normal",
      orphans: 2,
      textIndent: 0,
      textTransform: "none",
      widows: 2,
      wordSpacing: 0,
      WebkitTextStrokeWidth: 0,
      textDecorationThickness: "initial",
      textDecorationStyle: "initial",
      textDecorationColor: "initial",
      darkreaderInlineColor: "light-dark(#d8d4cf, #3a3632)",
      darkreaderInlineBorder: "var(--darkreader-border--darkreader-border--border-color)"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--darkreader-border--border-color)"
    }
  }, "("), "public)")))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1135,
    y: 161,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "s-comm...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-2"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1207.5,
    y: 142.18,
    width: 95,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 93,
      height: 1,
      paddingTop: 149,
      marginLeft: 1209
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    "data-darkreader-inline-border": "",
    "data-darkreader-inline-color": "",
    style: {
      borderColor: "var(--darkreader-border--border-color)",
      fontFamily: "Helvetica",
      fontSize: 12,
      fontStyle: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      letterSpacing: "normal",
      orphans: 2,
      textIndent: 0,
      textTransform: "none",
      widows: 2,
      wordSpacing: 0,
      WebkitTextStrokeWidth: 0,
      textDecorationThickness: "initial",
      textDecorationStyle: "initial",
      textDecorationColor: "initial",
      darkreaderInlineColor: "light-dark(#d8d4cf, #3a3632)",
      darkreaderInlineBorder: "var(--darkreader-border--darkreader-border--border-color)"
    }
  }, "s-stat"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
    "data-darkreader-inline-border": "",
    "data-darkreader-inline-color": "",
    style: {
      borderColor: "var(--darkreader-border--border-color)",
      fontFamily: "Helvetica",
      fontSize: 12,
      fontStyle: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      letterSpacing: "normal",
      orphans: 2,
      textIndent: 0,
      textTransform: "none",
      widows: 2,
      wordSpacing: 0,
      WebkitTextStrokeWidth: 0,
      textDecorationThickness: "initial",
      textDecorationStyle: "initial",
      textDecorationColor: "initial",
      darkreaderInlineColor: "light-dark(#d8d4cf, #3a3632)",
      darkreaderInlineBorder: "var(--darkreader-border--darkreader-border--border-color)"
    }
  }, "(private)")))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1255,
    y: 161,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "s-stat...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 40,
    width: 100,
    height: 30,
    fill: "#e3c800",
    stroke: "#b09500",
    pointerEvents: "all",
    style: {
      fill: "rgb(227, 200, 0)",
      stroke: "rgb(176, 149, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 55,
      marginLeft: 1200
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "/usr/local/grace")))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1200,
    y: 59,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "/usr/local/grace")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "L1MROEutppAufzN2r79q-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1255 110 L 1255 90 L 1196.38 90 L 1196.4 70.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "RyXrWw_IlzlAukWj9gDp-10"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 555,
    y: 10,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 25,
      marginLeft: 556
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "AWS")))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 30,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "15px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "AWS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 540 242.25 L 590 242.25 L 590 190 L 613.63 190",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 190 L 611.88 193.5 L 613.63 190 L 611.88 186.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 410 209.7 L 520 209.7 L 540 229.7 L 540 274.7 L 430 274.7 L 410 254.7 L 410 209.7 Z",
    fill: "#ffcccc",
    stroke: "#36393d",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 204, 204)",
      stroke: "rgb(54, 57, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 410 209.7 L 520 209.7 L 540 229.7 L 430 229.7 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 410 209.7 L 430 229.7 L 430 274.7 L 410 254.7 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 430 274.7 L 430 229.7 L 410 209.7 M 430 229.7 L 540 229.7",
    fill: "none",
    stroke: "#36393d",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(54, 57, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 252,
      marginLeft: 431
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "portal")))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 256,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "portal")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 540 460 L 590 460 L 590 310 L 613.63 310",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 618.88 310 L 611.88 313.5 L 613.63 310 L 611.88 306.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 410 409.5 L 520 409.5 L 540 429.5 L 540 479.67 L 430 479.67 L 410 459.67 L 410 409.5 Z",
    fill: "#ffcccc",
    stroke: "#36393d",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 204, 204)",
      stroke: "rgb(54, 57, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 410 409.5 L 520 409.5 L 540 429.5 L 430 429.5 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 410 409.5 L 430 429.5 L 430 479.67 L 410 459.67 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 430 479.67 L 430 429.5 L 410 409.5 M 430 429.5 L 540 429.5",
    fill: "none",
    stroke: "#36393d",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(54, 57, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 455,
      marginLeft: 431
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "portal")))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 458,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "portal")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 180 339.67 L 255 296.37 L 330 339.67 L 255 382.97 L 180 339.67 Z",
    fill: "#e3c800",
    stroke: "#b09500",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(227, 200, 0)",
      stroke: "rgb(176, 149, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 340,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "LB\xA0")), _div || (_div = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "(application)"))))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 343,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "LB...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--8"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 176,
    width: 275.5,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 274,
      height: 1,
      paddingTop: 183,
      marginLeft: 331
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    "data-darkreader-inline-border": "",
    "data-darkreader-inline-color": "",
    style: {
      borderColor: "var(--darkreader-border--border-color)",
      fontFamily: "Helvetica",
      fontSize: 12,
      fontStyle: "normal",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      letterSpacing: "normal",
      orphans: 2,
      textIndent: 0,
      textTransform: "none",
      widows: 2,
      wordSpacing: 0,
      WebkitTextStrokeWidth: 0,
      textDecorationThickness: "initial",
      textDecorationStyle: "initial",
      textDecorationColor: "initial",
      darkreaderInlineColor: "light-dark(#d8d4cf, #3a3632)",
      darkreaderInlineBorder: "var(--darkreader-border--darkreader-border--border-color)"
    }
  }, "grace.isstools.com", _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 195,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "grace.isstools.com&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--18"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 100,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 115,
      marginLeft: 642
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "PRIVATE DNS")))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 701,
    y: 119,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "PRIVATE DNS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--24"
  }, /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 149.36,
    width: 20,
    height: 25.64,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 611.19 175 C 610.61 174.82 610.16 174.36 610 173.78 L 610 160.9 C 610.14 160.29 610.59 159.8 611.19 159.6 L 612.66 159.6 L 612.66 156.19 C 612.68 154.38 613.44 152.65 614.77 151.41 C 616.1 150.17 617.9 149.52 619.73 149.61 C 621.65 149.36 623.59 149.94 625.05 151.2 C 626.5 152.46 627.34 154.28 627.34 156.19 L 627.34 159.6 L 628.6 159.6 C 629.28 159.74 629.83 160.24 630 160.9 L 630 173.78 C 629.82 174.37 629.34 174.84 628.73 175 Z M 621 172.48 L 621 167.15 C 621.94 166.7 622.45 165.67 622.22 164.66 C 621.99 163.65 621.08 162.93 620.03 162.93 C 618.97 162.93 618.06 163.65 617.83 164.66 C 617.6 165.67 618.11 166.7 619.06 167.15 L 619.06 172.48 Z M 624.93 159.6 L 624.93 156.06 C 624.72 153.56 622.52 151.69 619.99 151.85 C 617.47 151.72 615.3 153.58 615.1 156.06 L 615.1 159.6 Z",
    fill: "#e3c800",
    stroke: "#b09500",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(227, 200, 0)",
      stroke: "rgb(176, 149, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--26"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 250,
    width: 165,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 163,
      height: 1,
      paddingTop: 265,
      marginLeft: 174
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "PUBLIC IP ", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "+ FIREWALL/IP WHITELIST")))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 269,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "PUBLIC IP...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 330 339.75 L 370 339.75 L 370 232.25 L 403.63 232.21",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.88 232.2 L 401.89 235.71 L 403.63 232.21 L 401.88 228.71 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 330 339.75 L 370 339.75 L 370 434.63 L 403.63 434.59",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.88 434.59 L 401.89 438.09 L 403.63 434.59 L 401.88 431.09 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 540 242.25 L 680 242.25 L 680 540 L 703.63 540",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.88 540 L 701.88 543.5 L 703.63 540 L 701.88 536.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 540 460 L 590 460 L 590 560 L 703.63 560",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.88 560 L 701.88 563.5 L 703.63 560 L 701.88 556.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--59"
  }, /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 307,
    width: 108.88,
    height: 65.33,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 29.23 357.68 L 29.23 309.93 C 29.9 308.36 31.35 307.24 33.05 307 L 115.5 307 C 117.59 307.23 119.31 308.76 119.76 310.8 L 119.76 357.68 L 128.5 367.12 C 128.88 368.3 128.51 369.52 127.47 370.51 C 126.44 371.5 124.83 372.16 123.04 372.33 L 25.95 372.33 C 24.14 372.17 22.5 371.52 21.44 370.53 C 20.39 369.54 20 368.31 20.38 367.12 Z M 32.83 357.68 L 116.48 357.79 L 116.48 311.77 C 116.09 310.62 115.08 309.78 113.86 309.6 L 35.02 309.6 C 33.82 310.01 32.97 311.07 32.83 312.32 Z M 66.03 364.08 L 63.08 368.31 L 83.61 368.31 L 81.32 364.08 Z",
    fill: "#ffff88",
    stroke: "#36393d",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 136)",
      stroke: "rgb(54, 57, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "4QQG_8IH3QX1jVuvBs9--61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 128.88 339.63 L 154.5 339.63 L 172.58 339.72",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 177.83 339.75 L 170.81 343.22 L 172.58 339.72 L 170.85 336.22 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A6JmoFz1TFm3R6muNgtk-2"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 740,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 755,
      marginLeft: 726
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "atlas (hosted)")))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 785,
    y: 760,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "15px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "atlas (hosted)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "KinoSXWmXAQI8Y48_NnL-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 860 440 L 990 440 L 990 500 L 1052.13 499.71",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1058.88 499.68 L 1049.9 504.22 L 1052.13 499.71 L 1049.86 495.22 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 480 662.72 L 590 662.72 L 610 682.72 L 610 705 L 500 705 L 480 685 L 480 662.72 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480 662.72 L 590 662.72 L 610 682.72 L 500 682.72 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480 662.72 L 500 682.72 L 500 705 L 480 685 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 500 705 L 500 682.72 L 480 662.72 M 500 682.72 L 610 682.72",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 694,
      marginLeft: 501
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "S3")))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 698,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "13px",
    textAnchor: "middle"
  }, "S3")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-12"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.99,
    y: 706,
    width: 110,
    height: 17.73,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 715,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "&quot",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "fwupdate.signed")))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 720,
    fill: "#000000",
    fontFamily: "\"Helvetica\"",
    fontSize: "16px",
    textAnchor: "middle"
  }, "fwupdate.signed")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 196.87 674.23 L 223.36 683.78 L 223.36 702.72 L 196.87 693.17 Z M 198.18 672.43 L 209.76 668.19 L 236.64 677.86 L 224.93 682.07 Z M 239.91 676.64 L 213.03 667.01 L 225.06 662.72 L 251.75 672.35 Z M 253.12 674.27 L 253.12 693.13 L 226.7 702.68 L 226.7 683.82 Z",
    fill: "#00bef2",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 190, 242)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 450 683.1 Q 450 683.1 472.13 683.28",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 478.88 683.33 L 469.85 687.76 L 472.13 683.28 L 469.92 678.76 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 550 660 Q 660 510 717.53 335.97",
    fill: "none",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 29, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 719.65 329.56 L 721.1 339.52 L 717.53 335.97 L 712.55 336.69 Z",
    fill: "#001dbc",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 29, 188)",
      stroke: "rgb(0, 29, 188)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 540,
      marginLeft: 648
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF",
      backgroundColor: "#0000FF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "#0000FF",
      whiteSpace: "nowrap"
    }
  }, "\xA02\xA0")))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 648,
    y: 544,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\xA02\xA0"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 320 661.44 L 430 661.44 L 450 681.44 L 450 703.72 L 340 703.72 L 320 683.72 L 320 661.44 Z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 320 661.44 L 430 661.44 L 450 681.44 L 340 681.44 Z",
    fillOpacity: 0.05,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 320 661.44 L 340 681.44 L 340 703.72 L 320 683.72 Z",
    fillOpacity: 0.1,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 340 703.72 L 340 681.44 L 320 661.44 M 340 681.44 L 450 681.44",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 693,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "ARTIFACTS")))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 696,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ARTIFACTS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 253.12 682.68 Q 253.12 682.68 312.13 682.59",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 318.88 682.58 L 309.89 687.09 L 312.13 682.59 L 309.88 678.09 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 713.3 323.76 Q 610 450 542.49 652.54",
    fill: "none",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 29, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.35 658.94 L 538.93 648.98 L 542.49 652.54 L 547.47 651.82 Z",
    fill: "#001dbc",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 29, 188)",
      stroke: "rgb(0, 29, 188)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 482,
      marginLeft: 634
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF",
      backgroundColor: "#0000FF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "#0000FF",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "\xA0fwupdate\xA0"))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 634,
    y: 487,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "16px",
    textAnchor: "middle"
  }, "\xA0fwupdate\xA0")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 410,
      marginLeft: 631
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF",
      backgroundColor: "#0000FF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "#0000FF",
      whiteSpace: "nowrap"
    }
  }, "\xA01\xA0")))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 631,
    y: 414,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\xA01\xA0"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 862.55 309.02 Q 990 270 1054.63 339.25",
    fill: "none",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(0, 29, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1059.24 344.18 L 1049.81 340.67 L 1054.63 339.25 L 1056.39 334.53 Z",
    fill: "#001dbc",
    stroke: "#001dbc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "rgb(0, 29, 188)",
      stroke: "rgb(0, 29, 188)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "nxQMmvYxkB1rS9AH893d-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 281,
      marginLeft: 979
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#FFFFFF",
      backgroundColor: "#0000FF"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "#FFFFFF",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "#0000FF",
      whiteSpace: "nowrap"
    }
  }, "\xA03\xA0")))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 285,
    fill: "#FFFFFF",
    fontFamily: "\"Helvetica\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "\xA03\xA0")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrace);
export default __webpack_public_path__ + "static/media/grace.62348eb5883a7f7f16415b86f9a67636.svg";
export { ForwardRef as ReactComponent };